/**
 * Von Grundle Dialogue Tree (theme asset)
 *
 * Source of truth: quiz/von-grundle-dialogue-tree.json
 * This file exposes the full dialogue tree to the storefront as a cacheable
 * asset. dialogue-engine.js reads it via window.VG_DIALOGUE_TREE.
 * If you edit the JSON, regenerate/update this file to match.
 */
window.VG_DIALOGUE_TREE = {
  "meta": {
    "version": "1.0",
    "description": "Von Grundle Quiz Dialogue Tree - Interactive consultation experience",
    "author": "Von Grundle's Emporium",
    "notes": "Text in *[brackets]* represents stage directions/actions to be styled differently"
  },
  "config": {
    "typewriterSpeed": 30,
    "pauseDuration": {
      "short": 500,
      "medium": 1000,
      "long": 2000,
      "dramatic": 3000
    },
    "interventionChance": 0.15
  },
  "greetings": {
    "loggedIn": {
      "firstVisit": {
        "text": "Ah... *[firstName]*. I've been expecting you. The tea leaves were... specific this morning.",
        "animation": "vg-emerges-from-shadow"
      },
      "returnVisit": {
        "text": "Ah... *[firstName]*. Back again? *[checks imaginary ledger]* You DO seem to accumulate grievances. Has the situation evolved, or is this a NEW offense?",
        "animation": "vg-looks-up-from-book",
        "overrideOptions": [
          {
            "id": "same_situation",
            "label": "Same situation - I need more guidance",
            "goTo": "quiz_results_review"
          },
          {
            "id": "new_problem",
            "label": "New problem entirely",
            "goTo": "stage1"
          },
          {
            "id": "just_shopping",
            "label": "Just shopping today",
            "goTo": "exit_to_shop"
          }
        ]
      }
    },
    "guest": {
      "text": "Another seeker of arcane redress, I see. The rain always brings them. Come, come—don't drip on the grimoires.",
      "animation": "vg-gestures-welcome"
    }
  },
  "stages": {
    "stage1": {
      "id": "purpose",
      "prompt": "So then... what brings you to seek the counsel of Von Grundle this *[timeOfDay]*?",
      "options": [
        {
          "id": "vengeance",
          "label": "Someone has wronged me.",
          "response": "Ah, yes. The classic. *[settles into chair, steeples fingers]* Tell me of this... transgression.",
          "goTo": "branchA_offense",
          "tags": [
            "vengeance"
          ]
        },
        {
          "id": "gift",
          "label": "I seek a gift for someone deserving.",
          "response": "Generosity? In THIS economy? *[genuinely surprised]* How... refreshing. Tell me of this fortunate recipient.",
          "goTo": "branchB_relationship",
          "tags": [
            "gift"
          ]
        },
        {
          "id": "browse",
          "label": "I'm just looking around.",
          "response": "*[long, evaluating stare]*\n\nBrowsing. In MY emporium.\n\n*[even longer pause]*\n\n...Very well. But touch nothing that hums. And do NOT make eye contact with the thing in the corner.",
          "goTo": "branchC_guidance",
          "tags": [
            "browse"
          ]
        },
        {
          "id": "uncertain",
          "label": "I'm not entirely sure.",
          "response": "*[understanding nod]*\n\nThen we shall divine your purpose together. I have been waiting since before your great-grandparents drew breath. I have... *[gestures expansively]* ...time.",
          "goTo": "branchD_discovery",
          "tags": [
            "uncertain"
          ]
        }
      ]
    },
    "branchA_offense": {
      "id": "offense_type",
      "branch": "A",
      "prompt": "What is the nature of this... transgression?",
      "options": [
        {
          "id": "workplace",
          "label": "A workplace matter",
          "response": "Ah, the professional betrayal. The dagger between the shoulder blades, delivered with a smile and a calendar invite.",
          "goTo": "branchA_severity",
          "tags": [
            "workplace"
          ]
        },
        {
          "id": "neighbor",
          "label": "A neighbor situation",
          "response": "The ancient war between territories. I've seen civilizations crumble over less than a property line.",
          "goTo": "branchA_severity",
          "tags": [
            "neighbor"
          ]
        },
        {
          "id": "family",
          "label": "Family drama",
          "response": "Blood feuds. These run deep as dragon veins. *[pause]* ...Metaphorically speaking, of course.",
          "goTo": "branchA_severity",
          "tags": [
            "family"
          ],
          "dragonHint": true
        },
        {
          "id": "romantic",
          "label": "A romantic entanglement",
          "response": "Affairs of the heart are... *[long sigh]* ...complicated. Even for one as old as I.",
          "goTo": "branchA_severity",
          "tags": [
            "romantic"
          ]
        },
        {
          "id": "stranger",
          "label": "A stranger's offense",
          "response": "A random slight from one you may never see again? Curious. These fester most peculiarly in the mind.",
          "goTo": "branchA_severity",
          "tags": [
            "stranger"
          ]
        }
      ]
    },
    "branchA_severity": {
      "id": "severity",
      "branch": "A",
      "prompt": "And how grievous would you say this wrong was?",
      "options": [
        {
          "id": "minor",
          "label": "A mosquito bite of the soul",
          "response": "Ah, the petty irritations. My SPECIALTY, as it happens. The small indignities deserve attention too.",
          "goTo": "branchA_resolution",
          "tags": [
            "minor"
          ],
          "weight": 1
        },
        {
          "id": "moderate",
          "label": "A wound that lingers",
          "response": "These require more... considered remedies. The ache that doesn't fade. Yes, I understand this well.",
          "goTo": "branchA_resolution",
          "tags": [
            "moderate"
          ],
          "weight": 2
        },
        {
          "id": "severe",
          "label": "They have earned my eternal enmity",
          "response": "*[eyes flash gold for just a moment]*\n\n...I see. Then we speak not of petty vengeance, but of JUSTICE.",
          "goTo": "branchA_resolution",
          "tags": [
            "severe"
          ],
          "weight": 3,
          "dragonHint": true,
          "animation": "vg-eyes-flash"
        }
      ]
    },
    "branchA_resolution": {
      "id": "resolution",
      "branch": "A",
      "prompt": "What outcome would satisfy your wounded spirit?",
      "options": [
        {
          "id": "suffer",
          "label": "I want them to feel what I felt",
          "response": "The mirror's reflection. Classic. There is a certain... symmetry in such things.",
          "goTo": "vgvpi_quiz",
          "tags": [
            "suffer"
          ],
          "quizFraming": "vengeance_active"
        },
        {
          "id": "learn",
          "label": "I want them to understand what they did",
          "response": "Enlightenment through consequence. Elegant. You seek not pain but REALIZATION.",
          "goTo": "vgvpi_quiz",
          "tags": [
            "learn"
          ],
          "quizFraming": "vengeance_educational"
        },
        {
          "id": "peace",
          "label": "I want to release this and find peace",
          "response": "*[approving nod]*\n\nThe rarest request of all. Wisdom beyond your years. Let us find you... closure.",
          "goTo": "vgvpi_quiz",
          "tags": [
            "peace"
          ],
          "quizFraming": "vengeance_healing"
        }
      ]
    },
    "branchB_relationship": {
      "id": "relationship",
      "branch": "B",
      "prompt": "Who is this fortunate recipient to you?",
      "options": [
        {
          "id": "romantic_partner",
          "label": "A romantic partner",
          "response": "Romance. The eternal complication. *[knowing look]* Choose wisely. Gifts between lovers carry... weight.",
          "goTo": "branchB_personality",
          "tags": [
            "gift_romantic"
          ]
        },
        {
          "id": "friend",
          "label": "A dear friend",
          "response": "The family one chooses. The rarest treasure of all. They are fortunate to have such a friend.",
          "goTo": "branchB_personality",
          "tags": [
            "gift_friend"
          ]
        },
        {
          "id": "family_gift",
          "label": "A family member",
          "response": "Ah, the bonds of... obligation. *[meaningful pause]* ...Do you LIKE this relative?",
          "goTo": "branchB_family_followup",
          "tags": [
            "gift_family"
          ]
        },
        {
          "id": "professional",
          "label": "A colleague or professional contact",
          "response": "A professional gift. The art of appropriate bribery. A delicate dance, but one I know well.",
          "goTo": "branchB_personality",
          "tags": [
            "gift_professional"
          ]
        },
        {
          "id": "self",
          "label": "Myself, actually",
          "response": "*[slight, approving smile]*\n\nSelf-care disguised as shopping. I approve wholeheartedly. The best gifts are often self-given.",
          "goTo": "branchB_self_personality",
          "tags": [
            "gift_self"
          ]
        }
      ]
    },
    "branchB_family_followup": {
      "id": "family_like",
      "branch": "B",
      "prompt": "*[waits expectantly]*",
      "options": [
        {
          "id": "yes_like",
          "label": "Yes, very much",
          "response": "How fortunate. Genuine affection makes gift-giving a joy rather than an obligation.",
          "goTo": "branchB_personality",
          "tags": [
            "family_liked"
          ]
        },
        {
          "id": "complicated",
          "label": "It's... complicated",
          "response": "*[knowing nod]* Family often is. Let us find something that fulfills duty without compromising dignity.",
          "goTo": "branchB_personality",
          "tags": [
            "family_complicated"
          ]
        },
        {
          "id": "obligation",
          "label": "It's purely obligation",
          "response": "Ah. The obligatory gift. *[understanding]* I have just the thing. Impressive enough to satisfy, impersonal enough to maintain boundaries.",
          "goTo": "branchB_personality",
          "tags": [
            "family_obligation"
          ]
        }
      ]
    },
    "branchB_personality": {
      "id": "recipient_personality",
      "branch": "B",
      "prompt": "What stirs their spirit? What draws them?",
      "options": [
        {
          "id": "cozy",
          "label": "Cozy comforts - warm drinks, soft things, quiet evenings",
          "response": "A kindred spirit to my shop's ambiance. This pleases me greatly.",
          "goTo": "branchB_occasion",
          "tags": [
            "personality_cozy"
          ]
        },
        {
          "id": "dramatic",
          "label": "Bold statements - drama, flair, the theatrical",
          "response": "Someone after my own heart. EXCELLENT. I have just the things for such a soul.",
          "goTo": "branchB_occasion",
          "tags": [
            "personality_dramatic"
          ]
        },
        {
          "id": "practical",
          "label": "Practical function - no frills, just usefulness",
          "response": "*[mild but accepting disappointment]*\n\n...We can work with this. Even the practical among us deserve a touch of beauty.",
          "goTo": "branchB_occasion",
          "tags": [
            "personality_practical"
          ]
        },
        {
          "id": "mystical",
          "label": "Mystical and mysterious - the arcane and unusual",
          "response": "A seeker of the strange. *[approving]* They will feel at home among my wares.",
          "goTo": "branchB_occasion",
          "tags": [
            "personality_mystical"
          ]
        }
      ]
    },
    "branchB_self_personality": {
      "id": "self_personality",
      "branch": "B",
      "prompt": "And what calls to YOUR spirit?",
      "options": [
        {
          "id": "cozy_self",
          "label": "Cozy comforts - I want to feel wrapped in warmth",
          "response": "The cocoon of comfort. After centuries, I understand the appeal more than ever.",
          "goTo": "branchB_self_occasion",
          "tags": [
            "self_cozy"
          ]
        },
        {
          "id": "dramatic_self",
          "label": "Bold statements - I want something that makes me feel powerful",
          "response": "*[approving]*\n\nYes. You deserve to feel your own magnificence. Let us find you something worthy.",
          "goTo": "branchB_self_occasion",
          "tags": [
            "self_dramatic"
          ]
        },
        {
          "id": "comfort_self",
          "label": "Simple comfort - I'm going through something difficult",
          "response": "*[expression softens]*\n\nThen let us find you a small kindness. The world is hard enough.",
          "goTo": "branchB_self_occasion",
          "tags": [
            "self_comfort"
          ]
        }
      ]
    },
    "branchB_occasion": {
      "id": "occasion",
      "branch": "B",
      "prompt": "What occasion demands such tribute?",
      "options": [
        {
          "id": "birthday",
          "label": "A birthday",
          "response": "Another revolution around the sun. How they do accumulate.",
          "goTo": "gift_quiz",
          "tags": [
            "occasion_birthday"
          ]
        },
        {
          "id": "holiday",
          "label": "A holiday",
          "response": "The obligatory gifting season. The pressure is... immense. I understand completely.",
          "goTo": "gift_quiz",
          "tags": [
            "occasion_holiday"
          ]
        },
        {
          "id": "apology",
          "label": "An apology",
          "response": "Ahhhh. *[leans forward with considerable interest]*\n\nTell me what you did.\n\n*[pause]*\n\n...Actually, no. I don't need to know. The contrition in your eyes tells me enough.",
          "goTo": "gift_quiz",
          "tags": [
            "occasion_apology"
          ]
        },
        {
          "id": "just_because",
          "label": "No reason - just because",
          "response": "The spontaneous gesture! The BEST kind. Given freely, received with genuine surprise.",
          "goTo": "gift_quiz",
          "tags": [
            "occasion_spontaneous"
          ]
        },
        {
          "id": "support",
          "label": "They're going through something difficult",
          "response": "A balm for troubled times. *[softens]*\n\nNoble. Kindness given in darkness matters most.",
          "goTo": "gift_quiz",
          "tags": [
            "occasion_comfort"
          ]
        }
      ]
    },
    "branchB_self_occasion": {
      "id": "self_occasion",
      "branch": "B",
      "prompt": "And what prompts this act of self-kindness?",
      "options": [
        {
          "id": "treat",
          "label": "I just want to treat myself",
          "response": "As you should. Regularly and without guilt.",
          "goTo": "gift_quiz",
          "tags": [
            "self_treat"
          ]
        },
        {
          "id": "survived",
          "label": "I survived something difficult",
          "response": "*[respectful nod]*\n\nThen you have earned a reward. Let us mark your resilience.",
          "goTo": "gift_quiz",
          "tags": [
            "self_survived"
          ]
        },
        {
          "id": "struggling",
          "label": "I'm struggling and need something to hold onto",
          "response": "*[genuine warmth]*\n\nThen let us find you an anchor. Something small that reminds you: you are still here. That matters.",
          "goTo": "gift_quiz",
          "tags": [
            "self_struggling"
          ]
        }
      ]
    },
    "branchC_guidance": {
      "id": "browse_guidance",
      "branch": "C",
      "prompt": "Shall I... guide your wandering? Or do you prefer to stumble upon your fate unaided?",
      "options": [
        {
          "id": "guide_me",
          "label": "Show me what you recommend",
          "response": "Very well. Let us see what calls to you. *[gestures mysteriously toward the shadows]*",
          "goTo": "branchC_aesthetic",
          "tags": [
            "guided"
          ]
        },
        {
          "id": "wander",
          "label": "I'll explore on my own",
          "response": "Independent. I respect that.\n\nThe shop will reveal what it wishes to reveal. *[waves dismissively]*\n\nGo. Browse. Return when something finds you.",
          "goTo": "exit_to_shop",
          "tags": [
            "unguided"
          ],
          "exitBehavior": "floating_hints"
        }
      ]
    },
    "branchC_aesthetic": {
      "id": "aesthetic_vibe",
      "branch": "C",
      "prompt": "Do you prefer your atmosphere cozy... or dramatic?",
      "options": [
        {
          "id": "cozy_vibe",
          "label": "Cozy - warm and comforting",
          "response": "The gentle embrace. Yes, I understand.",
          "goTo": "branchC_scent",
          "tags": [
            "vibe_cozy"
          ]
        },
        {
          "id": "dramatic_vibe",
          "label": "Dramatic - bold and striking",
          "response": "A person of TASTE. Excellent.",
          "goTo": "branchC_scent",
          "tags": [
            "vibe_dramatic"
          ]
        },
        {
          "id": "both_vibe",
          "label": "Why not both?",
          "response": "*[pleased]*\n\nAh, a maximalist. You contain multitudes. As do my wares.",
          "goTo": "branchC_scent",
          "tags": [
            "vibe_both"
          ]
        }
      ]
    },
    "branchC_scent": {
      "id": "scent_preference",
      "branch": "C",
      "prompt": "And scent? Warm and spicy... or cool and herbal?",
      "options": [
        {
          "id": "warm_scent",
          "label": "Warm and spicy - cinnamon, amber, smoke",
          "response": "The dragon's palette. *[catches self]* ...That is to say, a sophisticated choice.",
          "goTo": "branchC_evening",
          "tags": [
            "scent_warm"
          ],
          "dragonHint": true
        },
        {
          "id": "cool_scent",
          "label": "Cool and herbal - eucalyptus, mint, forest",
          "response": "The mountain air. Clarifying. Brisk.",
          "goTo": "branchC_evening",
          "tags": [
            "scent_cool"
          ]
        },
        {
          "id": "complex_scent",
          "label": "Something complex and unexpected",
          "response": "*[intrigued]*\n\nA connoisseur. I have some... unusual offerings you might appreciate.",
          "goTo": "branchC_evening",
          "tags": [
            "scent_complex"
          ]
        }
      ]
    },
    "branchC_evening": {
      "id": "evening_preference",
      "branch": "C",
      "prompt": "Your ideal evening: fireplace with a book... or thunderstorm at the window?",
      "options": [
        {
          "id": "fireplace",
          "label": "Fireplace with a book",
          "response": "Peace. Warmth. The crackle of flames and turning pages. *[nostalgic]* I have spent many such evenings.",
          "goTo": "browse_results",
          "tags": [
            "evening_cozy"
          ]
        },
        {
          "id": "thunderstorm",
          "label": "Thunderstorm at the window",
          "response": "*[eyes brighten]*\n\nYes. The raw power of the storm. The electricity in the air. *[wistful]* It reminds me of... home.",
          "goTo": "browse_results",
          "tags": [
            "evening_dramatic"
          ],
          "dragonHint": true
        },
        {
          "id": "both_evening",
          "label": "Fireplace DURING a thunderstorm",
          "response": "*[delighted]*\n\nThe correct answer! Warmth within while chaos rages without. You understand the duality of existence.",
          "goTo": "browse_results",
          "tags": [
            "evening_both"
          ]
        }
      ]
    },
    "branchD_discovery": {
      "id": "morning_irritation",
      "branch": "D",
      "prompt": "Let us begin simply. When you woke this morning, what was the first irritation that crossed your mind?",
      "options": [
        {
          "id": "specific_person",
          "label": "A specific person's face appeared unbidden",
          "response": "Ahh. *[knowing]*\n\nThere it is. The subconscious knows what it knows. Tell me about this person.",
          "goTo": "branchA_offense",
          "tags": [
            "redirected_vengeance"
          ]
        },
        {
          "id": "everything_heavy",
          "label": "Just... everything feels heavy",
          "response": "The weight of the world. A common affliction in these times. Let us see if we can lighten the load.",
          "goTo": "branchD_heaviness",
          "tags": [
            "self_care_needed"
          ]
        },
        {
          "id": "vague_fog",
          "label": "Nothing specific, just a vague fog",
          "response": "*[nods slowly]*\n\nThe ennui. I know it well. Four centuries of it, in fact. Let us find you something that sparks.",
          "goTo": "branchD_spark",
          "tags": [
            "seeking_spark"
          ]
        }
      ]
    },
    "branchD_heaviness": {
      "id": "heaviness_source",
      "branch": "D",
      "prompt": "Is this heaviness from within... or from the world pressing in?",
      "options": [
        {
          "id": "internal",
          "label": "From within - my own thoughts and feelings",
          "response": "*[gently]*\n\nThe internal weather. Sometimes harder to escape than any storm outside. Let us find you something soothing.",
          "goTo": "self_care_quiz",
          "tags": [
            "internal_struggle"
          ]
        },
        {
          "id": "external",
          "label": "From outside - everything demanding my attention",
          "response": "The siege of obligations. The endless inbox. *[understanding]* You need respite, not products. But perhaps a small comfort to hold.",
          "goTo": "self_care_quiz",
          "tags": [
            "external_pressure"
          ]
        },
        {
          "id": "both_heavy",
          "label": "Both, honestly",
          "response": "*[sympathetic nod]*\n\nThe inside-outside conspiracy. I understand. When everything is loud, sometimes you need something quiet.",
          "goTo": "self_care_quiz",
          "tags": [
            "overwhelmed"
          ]
        }
      ]
    },
    "branchD_spark": {
      "id": "spark_seeking",
      "branch": "D",
      "prompt": "When was the last time you felt truly delighted by something small?",
      "options": [
        {
          "id": "recently",
          "label": "Recently - I just need more of those moments",
          "response": "Good. The capacity for delight is intact. Let us feed it.",
          "goTo": "branchC_aesthetic",
          "tags": [
            "delight_intact"
          ]
        },
        {
          "id": "cant_remember",
          "label": "I can't remember",
          "response": "*[concerned but not alarmed]*\n\nThen let us see if we can rekindle something. Sometimes a small pleasure reminds us pleasure exists.",
          "goTo": "discovery_quiz",
          "tags": [
            "delight_dormant"
          ]
        },
        {
          "id": "trying_to_feel",
          "label": "I'm trying to feel something, anything",
          "response": "*[meets your eyes with unexpected sincerity]*\n\nI hear you. That numbness is... difficult. Let us find you something with texture. Something real to hold.",
          "goTo": "discovery_quiz",
          "tags": [
            "seeking_feeling"
          ]
        }
      ]
    }
  },
  "interventions": {
    "petty_severe_mismatch": {
      "trigger": {
        "requires": [
          "minor",
          "suffer"
        ]
      },
      "text": "*[materializes on screen]*\n\nI must pause here. You want ETERNAL suffering for someone who committed a... *[checks notes]* ...mosquito bite offense?\n\n*[long, considering pause]*\n\nI ADORE you. Continue.",
      "animation": "vg-appears-amused"
    },
    "all_peaceful": {
      "trigger": {
        "requires": [
          "peace"
        ]
      },
      "text": "*[appears, slightly puzzled]*\n\nYou are remarkably well-adjusted. Are you CERTAIN you're in the right shop?\n\n*[pause]*\n\nNo matter. Even the serene deserve nice candles.",
      "animation": "vg-appears-questioning"
    },
    "dramatic_maximal": {
      "trigger": {
        "requires": [
          "severe",
          "suffer"
        ]
      },
      "text": "*[appears, clearly pleased]*\n\nFinally. A kindred spirit.\n\n*[dramatic gesture]*\n\nI have been WAITING for someone who appreciates... scale.",
      "animation": "vg-appears-excited"
    },
    "dragon_hints_accumulated": {
      "trigger": {
        "dragonHintCount": 3
      },
      "text": "*[catches self mid-sentence]*\n\n...I may be revealing too much of my nature. *[clears throat]*\n\nLet us continue. Pay no attention to any... slips.",
      "animation": "vg-looks-nervous"
    }
  },
  "exits": {
    "vgvpi_quiz": {
      "type": "quiz",
      "quizType": "full",
      "intro": "Now then. Let us assess your vindictive temperament in more detail..."
    },
    "gift_quiz": {
      "type": "quiz",
      "quizType": "gift",
      "intro": "A few more questions to ensure we find the perfect offering..."
    },
    "browse_results": {
      "type": "collection",
      "intro": "I believe I know just the collection to suit your... aesthetic."
    },
    "self_care_quiz": {
      "type": "quiz",
      "quizType": "selfcare",
      "intro": "Let us find you something comforting..."
    },
    "discovery_quiz": {
      "type": "quiz",
      "quizType": "discovery",
      "intro": "Let us excavate what might bring you joy..."
    },
    "exit_to_shop": {
      "type": "shop",
      "floatingHints": true
    },
    "quiz_results_review": {
      "type": "previous_results",
      "intro": "Ah yes, I recall your consultation. Let us review..."
    }
  },
  "productMappings": {
    "vengeance_workplace_minor": {
      "primary": [
        "petty-vengeance-scroll-office",
        "desk-candle-spite"
      ],
      "secondary": [
        "revenge-incense-subtle"
      ]
    },
    "vengeance_workplace_severe": {
      "primary": [
        "full-consultation",
        "justice-candle"
      ],
      "secondary": [
        "corporate-curse-scroll"
      ]
    },
    "vengeance_neighbor_any": {
      "primary": [
        "territorial-incense",
        "boundary-candle"
      ],
      "secondary": [
        "petty-vengeance-scroll-neighbor"
      ]
    },
    "gift_cozy_any": {
      "primary": [
        "comfort-candle-set",
        "cozy-evening-bundle"
      ],
      "secondary": [
        "warming-incense"
      ]
    },
    "gift_dramatic_any": {
      "primary": [
        "statement-candle",
        "dragons-hoard-set"
      ],
      "secondary": [
        "theatrical-incense"
      ]
    },
    "self_struggling": {
      "primary": [
        "gentle-comfort-candle",
        "self-care-scroll"
      ],
      "secondary": [
        "soothing-incense"
      ],
      "tone": "gentle"
    },
    "browse_cozy_warm": {
      "collection": "cozy-evening-collection"
    },
    "browse_dramatic_cool": {
      "collection": "midnight-storm-collection"
    }
  },
  "dynamicText": {
    "timeOfDay": {
      "morning": "morning",
      "afternoon": "afternoon",
      "evening": "evening",
      "night": "witching hour"
    },
    "weatherReferences": {
      "rain": "The rain always brings seekers to my door.",
      "sunny": "You come to a dark shop on such a bright day? Interesting.",
      "default": "The candles have been flickering strangely all day."
    }
  }
};
